import React, { useState } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { phoneValidation } from '../../flows/shared/validations';
import { handleInputFormat } from '../../flows/shared/utils';
import { parsePhoneForDisplay } from './utils';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import plusIcon from '../../assets/images/plus-icon.svg';
import styles from './styles.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

export const AdditionalPhoneNumber = ({
  authenticated,
  phone,
  setPhone,
  phoneFormProps,
  phoneClass,
  dataName
}) => {
  const [phoneValue, setPhoneValue] = useState('');
  const deleteButtonDataID = phoneClass?.includes('3')
    ? 'EveningPhoneNumberDeleteButton'
    : 'DaytimePhoneNumberDeleteButton';
  return phone ? (
    <>
      <div className={phoneClass}>
        <InputField
          title="Additional phone number"
          placeholder="(000) 000-0000"
          autocomplete="new-password"
          maxLength="14"
          validation={phoneValidation}
          data-name={dataName}
          {...phoneFormProps}
          value={typeof phone === 'string' ? phone : phoneValue}
          onChange={evt => handleInputFormat(evt, 'PHONE', setPhoneValue)}
          className="blocked_data"
        />
      </div>
      {authenticated || (
        <span className="delete-phone-number-btn">
          <MFBeaconButton
            id={`deletePhoneNumberBtn-${phoneClass}`}
            data-name={generateGeneralTestID(
              'ContactInformation',
              deleteButtonDataID
            )}
            onClick={() => setPhone(false)}
            className="override-beacon-button-padding"
            type="button"
            variant="tertiary"
            label="remove"
          />
        </span>
      )}
      <style jsx>{styles}</style>
    </>
  ) : null;
};

/* eslint-disable */

const AdditionalPhoneNumberFields = ({ formProps, appState }) => {
  const { store } = appState || {};
  const { authenticated = false, app } = store || {};
  const { customer } = app || {};
  const { phones = [] } = customer || {};

  const setInitialDefaultPhone = (value, authenticatedFlag) =>
    value || authenticatedFlag || false;
  const [phone2, setPhone2] = useState(
    phones
      ? setInitialDefaultPhone(
          parsePhoneForDisplay(phones, 'DAYTIME'),
          authenticated
        )
      : false
  );
  const [phone3, setPhone3] = useState(
    phones
      ? setInitialDefaultPhone(
          parsePhoneForDisplay(phones, 'EVENING'),
          authenticated
        )
      : false
  );

  return (
    <>
      <div className="additional-phone-fields">
        {phone2 && (
          <AdditionalPhoneNumber
            phone={phone2}
            setPhone={setPhone2}
            authenticated={authenticated}
            phoneFormProps={formProps.phone2}
            phoneClass="phone-input2"
            dataName={generateGeneralTestID(
              'ContactInformation',
              'AccountOwnerDaytimePhoneNumber'
            )}
          />
        )}

        {phone3 && (
          <AdditionalPhoneNumber
            phone={phone3}
            setPhone={setPhone3}
            authenticated={authenticated}
            phoneFormProps={formProps.phone3}
            phoneClass={phone2 && phone3 ? 'phone-input3' : 'input-only-phone3'}
            dataName={generateGeneralTestID(
              'ContactInformation',
              'AccountOwnerEveningPhoneNumber'
            )}
          />
        )}

        {!phone3 && (
          <span className={phone2 ? 'add-phone-btn2' : 'add-phone-btn'}>
            <MFBeaconButton
              id="addPhoneBtn"
              data-name={generateGeneralTestID(
                'ContactInformation',
                'AddPhoneNumberButton'
              )}
              onClick={() => (phone2 ? setPhone3(true) : setPhone2(true))}
              type="button"
              variant="tertiary"
              icon-align="left"
              label="Add another phone number">
              <img slot="icon" src={plusIcon} alt="plus icon" />
            </MFBeaconButton>
          </span>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default AdditionalPhoneNumberFields;
